import { v1ApiClient } from '@/services';
import type { PathParams } from '@/shared/api/generated';

type QualtricsPath = '/v1/workspaces/{workspace_id}/qualtrics';

/**
 * Qualtrics 연동 해제
 */
export const deleteQualtricsInfo = ({
  workspace_id,
}: PathParams<QualtricsPath, 'delete'>): Promise<void> =>
  v1ApiClient
    .delete(`/workspaces/${workspace_id}/qualtrics`)
    .then((res) => res.data);
